module.exports = __webpack_public_path__ + "img/sauce.59a3ba1e.svg";